import { render, staticRenderFns } from "./PotInternalDetail.vue?vue&type=template&id=0cb88e4b&"
import script from "./PotInternalDetail.vue?vue&type=script&lang=js&"
export * from "./PotInternalDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports